module.exports = __webpack_public_path__ + "static/img/6.93d57ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/6.png
// module id = 9kmS
// module chunks = 0